module.exports = __webpack_public_path__ + "img/logo_dark.e709b840.png";